// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f07bc0f2","545":"5f0a6f04","787":"97c85f4e"}[chunkId] + ".chunk.js";
};